import {
    BettingWidgets,
    BettingWidgetsOptions,
    WidgetPortalContainer,
} from '../types';

export default function checkWidgetContainerProvided<T extends BettingWidgets>(
    widget: BettingWidgetsOptions[T]
): widget is Required<WidgetPortalContainer> {
    return (widget as WidgetPortalContainer).containerElementId !== undefined;
}
